import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
    getReferralReward, 
    addReferralReward as postReferralReward, 
    updateReferralReward as putReferralReward, 
    deleteReferralReward as removeReferralReward,
    activateDeactivateReferralReward as activateReferralReward,
    uploadImages,
    uploadDoc
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchReferralRewardTableColumnNames = createAsyncThunk("referralReward/fetchTableColumnNames", async (referralReward, thunkAPI) => {
    try {
      const response = await getHeaders(referralReward); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllReferralReward = createAsyncThunk("referralReward/fetchAll", async (thunkAPI) => {
    try {
      const response = await getReferralReward(); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Course
export const createReferralReward = createAsyncThunk("referralReward/add", async (referralReward, thunkAPI) => {  
    try {
        const response = await postReferralReward(referralReward);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Course
export const updateReferralReward = createAsyncThunk("referralReward/update", async (referralReward, thunkAPI) => {
    try {
        const response = await putReferralReward(referralReward);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Course
export const deleteReferralReward = createAsyncThunk("referralReward/delete", async (referralReward, thunkAPI) => {
    try {
        const response = await removeReferralReward(referralReward);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Activate deactivate referral reward 
export const activateDeactivateReferralReward = createAsyncThunk("referralReward/activateDeactivate", async (referralReward, thunkAPI) => {
  try {
    const response = await activateReferralReward(referralReward);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Upload Documnet 
export const uploadReferrelDoc = createAsyncThunk(
  "referralReward/uploadReferrelDoc",
  async (doc, thunkAPI) => {
  try {
    const response = await uploadDoc(doc);
    if (response.IsSuccess) {
      toast.success(t(response.message) || "Image uploaded successfully!");
      return response.Data; 
    } else {
      toast.error(t(response.message) || "Failed to upload image.");
      return thunkAPI.rejectWithValue(response);
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});
